export default __webpack_public_path__ + "static/media/specialist_consultation.15c45831.svg";